class MediaSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-media-slider-track]');
    this.slides = Array.from(root.querySelectorAll('.media-slider__slide'));
    this.prevBtn = root.querySelector('[data-media-slider-prev]');
    this.nextBtn = root.querySelector('[data-media-slider-next]');
    this.dots = Array.from(root.querySelectorAll('[data-media-slider-dot]'));
    this.index = 0;
    this.scrollTimeout = null;

    if (this.slides.length <= 1) {
      this.setActive(0);
      return;
    }

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
    });

    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
    this.setActive(0);
  }

  go(i) {
    const max = this.slides.length - 1;
    const idx = Math.max(0, Math.min(i, max));
    this.slides[idx].scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }

  onScroll() {
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      const trackRect = this.track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let minDist = Infinity;
      this.slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const dist = Math.abs(rect.left + rect.width / 2 - center);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      if (closest !== this.index) this.setActive(closest);
    }, 80);
  }

  setActive(i) {
    this.index = i;
    this.slides.forEach((slide, idx) => {
      slide.classList.toggle('is-active', idx === i);
      const video = slide.querySelector('video');
      if (!video) return;
      if (idx === i) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    this.dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === i));
  }
}

document.querySelectorAll('[id^="MediaSlider-"]').forEach((el) => new MediaSlider(el));